import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { TabsComponent } from "./TabsComponent";

import Card from '@material-ui/core/Card';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import TextField from "../../Partials/Material/TextField";

class Savings extends Component {
  public selectedCompany: CompanyInterface = null;
  protected textFieldRef;

  public state = {
    filterValue: this.props.app?.savingsFilterSearchState,
    anchorEl: null
  };

  constructor(public props) {
    super(props);

    this.textFieldRef = React.createRef();
  }

  protected openMenu = (event: any, company: CompanyInterface): void => {
    this.selectedCompany = company;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public setFilterValue = (event: any): void => {
    const filterValue: string = event.target.value;

    this.setState({
      filterValue: filterValue
    }, () => {
      this.props.dispatch({
        type: Constants.SAVINGS_FILTER_SEARCH_UPDATE_STATE,
        payload: {
          filter: this.state.filterValue
        }
      });
    });
  }

  public deUmlaut(value){
    if (!value) {
      return "";
    }

    value = value.toLowerCase();
    value = value.replace(/ä/g, 'a');
    value = value.replace(/ö/g, 'o');
    value = value.replace(/ü/g, 'u');
    value = value.replace(/ß/g, 'ss');
    value = value.replace(/ /g, '-');
    value = value.replace(/\./g, '');
    value = value.replace(/,/g, '');
    value = value.replace(/\(/g, '');
    value = value.replace(/\)/g, '');

    return value;
  }

  public searchFilterSavings = () => {
    return this.props.app.companies
      .filter((company: CompanyInterface) => !!company && !company.removed && (company?.isOwner || company?.isAgency))
      .reduce((arr, company) => {
        // Search display name
        if (company.displayName && company.displayName.toLowerCase().includes(this.state.filterValue.toLowerCase()) === true) {
          arr.push({
            company: company
          });
          return arr;
        } else {
          // try to search again after deUmlaut
          if (this.deUmlaut(company.displayName).toLowerCase().includes(this.state.filterValue.toLowerCase()) === true) {
            arr.push({
              company: company
            });
            return arr;
          } else {
            // try to change word positions
            let stringArr = this.state.filterValue.toLocaleLowerCase().split(" ");
            stringArr = stringArr.map((string, index) => {
              if (index !== stringArr.length - 1) {
                return string + " ";
              }

              else {
                return string;
              };
            });

            let isIncluded = true;

            stringArr.forEach(string => {
              if (!(company.displayName && (company.displayName.toLowerCase() + " ").includes(string))) {
                isIncluded = false;
              }
            })

            if (isIncluded) {
              arr.push({
                company: company
              });
              return arr;
            } else {
              let isIncluded = true;

              stringArr.forEach(string => {
                if (!((this.deUmlaut(company.displayName).toLowerCase() + " ").includes(string))) {
                  isIncluded = false;
                }
              })

              if (isIncluded) {
                arr.push({
                  company: company
                });
                return arr;
              }
            }
          }
        }

        // Search email
        if (company.email && company.email.toLowerCase().includes(this.state.filterValue.toLowerCase()) === true) {
          arr.push({
            company: company
          });
          return arr;
        } else {
          // try to search again after deUmlaut
          if (this.deUmlaut(company.email).toLowerCase().includes(this.state.filterValue.toLowerCase()) === true) {
            arr.push({
              company: company
            });
            return arr;
          }
        }

        return arr;
      }, [])
      .map(res => res.company);
  }

  public getOwners = (): JSX.Element[] => {
    // Filter, sort, and transform companies into table rows.
    return this.searchFilterSavings()
      .filter(company => company?.savingsAccount !== 0) // Filters out companies without savings account.
      .sort((a, b) => a.name.localeCompare(b.name)) // Sorts companies by name.
      .map((company, index) => this.renderCompanyRow(company, index));
  }
  
  private renderCompanyRow = (company: CompanyInterface, key: number): JSX.Element => {
    // Extract and format property details for display.
    const propertyDetails = this.getPropertyDetails(company.properties);
  
    return (
      <TableRow
        hover
        key={key}
        className="clickable-entity"
        onClick={() => this.handleRowClick(company)}
      >
        <TableCell style={{ width: "50px" }}>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            {company.renderAvatar()}
          </div>
        </TableCell>
        <TableCell style={{ width: "30%" }}>{company.displayName}</TableCell>
        <TableCell style={{ width: "55%" }}>{propertyDetails}</TableCell>
        <TableCell style={{ width: "15%", textAlign: "right" }}>
          {this.formatter.formatNumber(company.savingsAccount, this.props.app?.settings?.user?.currency)}
        </TableCell>
        <TableCell onClick={(e) => e.stopPropagation()}>
          {this.renderMenu(company)}
        </TableCell>
      </TableRow>
    );
  }
  
  private getPropertyDetails = (properties): string => {
    return properties.slice(0, 3).map(property => {
      return property?.address?.route || property?.address?.formattedAddress || '';
    }).filter(detail => detail).join(', ');
  }
  
  private handleRowClick = (company: CompanyInterface) => {
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_SWITCH_TAB,
      payload: {
        index: Constants.COMPANY_DETAILS_SAVINGS_TAB,
        companyId: company.id
      }
    });
  
    const routePath = company.isOwner ? `/app/owner/update/${company.id}` : `/app/agency/update/${company.id}`;
    this.redirect(routePath);
  }
  
  private renderMenu = (company: CompanyInterface): JSX.Element => (
    <div>
      <IconButton onClick={(e) => this.openMenu(e, company)}>
        <div className="icon icon-ic-more-vert"></div>
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={this.state.anchorEl}
        open={Boolean(this.state.anchorEl) && this.selectedCompany && this.selectedCompany.id === company.id}
        onClose={this.closeMenu}
        disableAutoFocusItem
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        getContentAnchorEl={null}
      >
        <MenuItem onClick={() => this.handleMenuItemClick(company)}>
          <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
          <ListItemText>{this.trans("menuitem-open")}</ListItemText>
        </MenuItem>
      </Menu>
    </div>
  )
  
  private handleMenuItemClick = (company: CompanyInterface) => {
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_SWITCH_TAB,
      payload: {
        index: Constants.COMPANY_DETAILS_SAVINGS_TAB,
        companyId: company.id
      }
    });
  
    this.redirect(company.isOwner ? `/app/owner/update/${company.id}` : `/app/agency/update/${company.id}`);
  }

  
  public render() {
    return (
      <div className="state-app">
        <div className={`box box-full component-finance full-width has-general-page-header with-tabs ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <h1>{this.trans("title-finance")}</h1>
            <TabsComponent
              {...this.props}
              activeTab={3}
            />
          </div>

          <div className="component-wrapper no-borders no-margin-top">
            <Card className="card">
              <div className="label-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline"
                }}
              >
                <h3 className="card-title" style={{flexDirection: "column", display: "flex"}}>
                  {this.trans("title-savings")}
                </h3>
              </div>
              <div>
                <div
                  className="list-filters-wrapper"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end"
                  }}
                >
                  <div className="table-filterer">
                    <TextField
                      autoComplete="off"
                      type="text"
                      style={{color: "rgb(0, 188, 212)"}}
                      label={this.trans("label-search")}
                      value={this.state.filterValue}
                      onChange={this.setFilterValue}
                      variant="standard"
                      error={false}
                      inputRef={this.textFieldRef}
                    />
                    { this.state.filterValue !== "" &&
                      <div
                        className="icon icon-ic-close clear-button clear-button-search"
                        onClick={() => {
                          this.setState({filterValue: ""}, () => {
                            this.props.dispatch({
                              type: Constants.SAVINGS_FILTER_SEARCH_UPDATE_STATE,
                              payload: {
                                filter: this.state.filterValue
                              }
                            });
                          });
                          this.textFieldRef.current.focus();
                        }}
                      ></div>
                    }
                  </div>
                </div>
              </div>
              <TableComponent
                {...this.props}
                className={"persons-listing-table listing-table finance-savings-listing-table with-first-border"}
                headers={[
                  "", this.trans("owner"), this.trans("title-properties"), this.trans("section/invoice-label/amount"), "", ""
                ]}
                paginator={{
                  name: "OwnersSavings",
                  path: this.props.app.paginator
                }}
                rows={this.getOwners()}
                subtitle={this.trans("no-companies-to-list")}
                defaultPaginationAmount={30}
              />
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.ownerStatements,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Savings
);
